module.exports = __webpack_public_path__ + "img/43_60.0637be5e.png";